import { createClientTimings } from './lib/client-perf.mjs';

// At most two small beacons per document, no polling. Vitals are measured by
// next/web-vitals. Custom samples contain durations, never terms or record IDs.
try {
  const metrics = {};
  let samples = [];
  let sampleCount = 0;
  let sent = 0;
  const timings = createClientTimings({
    now: () => performance.now(),
    visible: () => document.visibilityState === 'visible',
    record: (name, ms) => {
      metrics[name] = ms;
      if (name === 'crm_rows_ready' && sampleCount < 20) { samples.push(ms); sampleCount++; }
    },
  });
  const bootstrap = timings.start('bootstrap_ready');
  window.__pbPerfStart = (name) => name === 'crm' ? timings.start('crm_rows_ready') : null;
  window.__pbPerfMark = (name, token) => {
    if (name === 'bootstrap_ready') timings.finish(name, bootstrap);
    else if (name === 'crm_rows_ready') timings.finish(name, token);
  };
  window.__pbPerfVital = (name, value) => {
    if (['lcp', 'cls', 'inp'].includes(name) && Number.isFinite(value)) {
      metrics[name] = name === 'cls' ? Number(value.toFixed(4)) : Math.round(value);
    }
  };
  const send = () => {
    if (sent >= 2 || (!Object.keys(metrics).length && !samples.length) || typeof navigator.sendBeacon !== 'function') return;
    const path = ['/', '/finance', '/login'].includes(location.pathname) ? location.pathname : '/other';
    if (navigator.sendBeacon('/api/performance', new Blob([JSON.stringify({ metrics, samples, path, version: 2 })], { type: 'application/json' }))) {
      sent++;
      for (const key of Object.keys(metrics)) delete metrics[key];
      samples = [];
    }
  };
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') timings.hide();
  });
  addEventListener('pagehide', send, { once: true });
  setTimeout(send, 15000);
} catch { /* Performance reporting must never affect CRM work. */ }
